<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style scoped lang="scss">
h1 {
  margin: 200px auto;
  font-size: 24px;
}
a {
  color: #42b983;
}
</style>
